/* eslint-disable react-refresh/only-export-components */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext } from "react";

type DocumentProviderProp = {
  children: React.ReactNode;
  state: any;
  setState: any;
  searchAddress: any;
  updateAddress: any;
  searchSupplier: any;
  updateSupplierMapping: any;
  searchItemMaster: any;
  updateItemMaster: any;
  mutationMasterData: any;
  onUpdateIsSimilarityMatch: any;
  onIgnorePriceValidations: (prop: any) => void;
  ignorePriceValidations: any;
  showBranchId: boolean;
  isReadOnly: boolean;
};

export const DocumentContext = createContext<any>(null); // Default value can be null or any initial state.

export const DocumentProvider = ({
  children,
  state,
  setState,
  searchAddress,
  updateAddress,
  searchSupplier,
  updateSupplierMapping,
  searchItemMaster,
  updateItemMaster,
  mutationMasterData,
  onUpdateIsSimilarityMatch,
  onIgnorePriceValidations,
  ignorePriceValidations,
  showBranchId,
  isReadOnly,
}: DocumentProviderProp) => {
  return (
    <DocumentContext.Provider
      value={[
        state,
        setState,
        searchAddress,
        updateAddress,
        searchSupplier,
        updateSupplierMapping,
        searchItemMaster,
        updateItemMaster,
        mutationMasterData,
        onUpdateIsSimilarityMatch,
        onIgnorePriceValidations,
        ignorePriceValidations,
        showBranchId,
        isReadOnly,
      ]}
    >
      {children}
    </DocumentContext.Provider>
  );
};
